import { render, staticRenderFns } from "./shipmentCharge.vue?vue&type=template&id=56a3be86&scoped=true"
import script from "./shipmentCharge.vue?vue&type=script&lang=js"
export * from "./shipmentCharge.vue?vue&type=script&lang=js"
import style0 from "./shipmentCharge.vue?vue&type=style&index=0&id=56a3be86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a3be86",
  null
  
)

export default component.exports